export function cartCountEvents() {
	const config = window.fluxWooAjax;
	if (!config?.cartCountUrl) {
		return;
	}

	const countEl = document.querySelector("[data-cart-count]");
	if (!countEl) {
		return;
	}

	const updateCount = (value) => {
		const parsed = Number.parseInt(value, 10);
		const count = Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
		countEl.textContent = String(count);
		countEl.hidden = count === 0;
	};

	fetch(config.cartCountUrl, { credentials: "same-origin" })
		.then((response) => {
			if (!response.ok) {
				throw new Error("Cart count request failed");
			}
			return response.json();
		})
		.then((payload) => {
			if (!payload?.success) {
				return;
			}
			updateCount(payload.data?.count);
		})
		.catch(() => {});
}
